const BV = function() {
    var u = navigator.userAgent;
    const trident = u.indexOf('Trident') > -1; //IE内核
    const presto = u.indexOf('Presto') > -1; //opera内核
    const webKit = u.indexOf('AppleWebKit') > -1; //苹果、谷歌内核
    const gecko = u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1;//火狐内核
    const mobile = !!u.match(/AppleWebKit.*Mobile.*/); //是否为移动终端
    const ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    const android = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    const iPhone = u.indexOf('iPhone') > -1; //是否为iPhone或者QQHD浏览器
    const iPad = u.indexOf('iPad') > -1; //是否iPad
    const webApp = u.indexOf('Safari') == -1; //是否web应该程序，没有头部与底部
    const weixin = u.indexOf('MicroMessenger') > -1; //是否微信 （2015-01-22新增）
    const qq = u.match(/\sQQ/i) == " qq"; //是否QQ
    const wxapp = weixin && window.__wxjs_environment === 'miniprogram'; //微信小程序
    return {
        trident,
        presto,
        webKit,
        gecko,
        mobile,
        ios,
        android,
        iPhone,
        iPad,
        webApp,
        weixin,
        qq,
        wxapp
    };
}

//ios原生交互
const setupWKWebViewJavascriptBridge = function(callback) {
    if(!BV().wxapp){
        if(window.webkit && window.webkit.messageHandlers){
            if (window.WKWebViewJavascriptBridge) { return callback(WKWebViewJavascriptBridge); }
            if (window.WKWVJBCallbacks) { return window.WKWVJBCallbacks.push(callback); }
            window.WKWVJBCallbacks = [callback];
            window.webkit.messageHandlers.iOS_Native_InjectJavascript.postMessage(null)
        }else{
            callback(null);
        }
    }else{
        callback(null);
    }
}
//时间格式化
const dateFormat = function(date,fmt){
    if(!date) return;
    if(typeof date != 'object')date = new Date(date.replace(/-/g,'/').replace(/T|Z/g,' '));
    if(date == 'Invalid Date'){
        return '';
    }else{
        return (function (fmt){
            var o = {
                "M+": this.getMonth() + 1,
                "d+": this.getDate(),
                "H+": this.getHours(),
                "m+": this.getMinutes(),
                "s+": this.getSeconds(),
                "q+": Math.floor((this.getMonth() + 3) / 3),
                "S": this.getMilliseconds()
            };
            fmt = fmt || "yyyy-MM-dd";
            if (/(y+)/.test(fmt))
                fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
            let HoursStyle = [],hoursText='';
            if(new RegExp("(12H)").test(fmt)){
                HoursStyle = ['AM','PM'];
            }else if(new RegExp("(12h)").test(fmt)){
                HoursStyle = ['am','pm'];
            }
            if(HoursStyle.length > 0){
                let hours = parseInt(date.getHours());
                if(hours == 0){
                    hoursText = '12' + HoursStyle[0];
                }else{
                    hoursText = hours >= 12 ? (hours-12 + HoursStyle[1]) : (hours + HoursStyle[0]);
                }
                fmt = fmt.replace(RegExp.$1, 'EE');
            }
            for (var k in o)
                if (new RegExp("(" + k + ")").test(fmt))
                    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
            fmt = fmt.replace('EE', hoursText);
            return fmt;
        }).call(date,fmt);
    }
}
//转中文
const numberToChinese = function(number){
    if(number == null || number == undefined) return '';
    /*
        单位
    */
    var units = '个十百千万@#%亿^&~';
    /*
        字符
    */
    var chars = '零一二三四五六七八九';
    /*
        数字转中文
        @number {Integer} 形如123的数字
        @return {String} 返回转换成的形如 一百二十三 的字符串            
    */
     var  a=(number+ '' ).split( '' ),s=[] ;
     if (a.length>12){
         throw  new  Error( 'too big' );
     } else {
         for ( var  i=0,j=a.length-1;i<=j;i++){
             if (j==1||j==5||j==9){ //两位数 处理特殊的 1*
                 if (i==0){
                     if (a[i]!= '1' )s.push(chars.charAt(a[i]));
                 } else {
                     s.push(chars.charAt(a[i]));
                 }
             } else {
                 s.push(chars.charAt(a[i]));
             }
             if (i!=j){
                 s.push(units.charAt(j-i));
             }
         }
     }
     //return s;
     return  s.join( '' ).replace(/零([十百千万亿@ #%^&~])/g,function(m,d,b){//优先处理 零百 零千 等
         b = units.indexOf(d);
         if (b!=-1){
             if (d== '亿' ) return  d;
             if (d== '万' ) return  d;
             if (a[j-b]== '0' ) return  '零'
         }
         return  '' ;
     }).replace(/零+/g, '零' ).replace(/零([万亿])/g, function (m,b){ // 零百 零千处理后 可能出现 零零相连的 再处理结尾为零的
         return  b;
     }).replace(/亿[万千百]/g, '亿' ).replace(/[零]$/, '' ).replace(/[@ #%^&~]/g,function(m){
         return  { '@' : '十' , '#' : '百' , '%' : '千' , '^' : '十' , '&' : '百' , '~' : '千' }[m];
     }).replace(/([亿万])([一-九])/g, function (m,d,b,c){
         c=t.units.indexOf(d);
         if (c!=-1){
             if (a[j-c]== '0' ) return  d+ '零' +b
         }
         return  m;
     });
 }
//添加省略号
const ellipsis = function(value,length){
    if(value && value.length > length){
        return value.substr(0,length)+'...';
    }else {
        return value;
    }
}
//隐藏信息
const textEncryption = function(text, start = 0, end = 0, symbol = '...'){
    if(!text || (start == 0 && end == 0)) return text;
    return text.replace(new RegExp(`^.{${start}}([\\s\\S]*?).{${end}}$`,'ig'),function(p1, p2){
        if(p2){
            return text.replace(p2,symbol);
        }else{
            return text;
        }
    });
}
//通过身份证计算年龄和性别
const analyzeIDCard = function(IDCard) {
    var sexAndAge = {};
    //获取用户身份证号码
    var userCard = IDCard;
    //如果身份证号码为undefind则返回空
    if(!userCard){
        return null;
    }
    //获取性别
    if(parseInt(userCard.substr(16,1)) % 2 == 1){
        sexAndAge.sex = 0//（男）
    }else{
        sexAndAge.sex = 1//（女）
    }
    //获取出生年月日
    //userCard.substring(6,10) + "-" + userCard.substring(10,12) + "-" + userCard.substring(12,14);
    var yearBirth = userCard.substring(6,10);
    var monthBirth = userCard.substring(10,12);
    var dayBirth = userCard.substring(12,14);
    sexAndAge.dateBirth = yearBirth + "-" + monthBirth + "-" + dayBirth;
    //获取当前年月日并计算年龄
    var myDate = new Date();
    var monthNow = myDate.getMonth() + 1;
    var dayNow = myDate.getDay();
    var age = myDate.getFullYear() - yearBirth;
    //得到年龄
    sexAndAge.age = age;
    //返回性别和年龄
    return sexAndAge;
}
//获取根元素的fantsize 计算实际尺寸
const convertSize = function(rem){
    var fontsize = parseFloat(document.querySelector('html').style.fontSize);
    return fontsize * rem;
}
//身份证号校验，信息读取
const identityCard = function(IDCard){
    //基础格式校验
    if(!IDCard || !/^(1[1-5]|2[1-3]|3[1-7]|4[1-6]|5[0-4]|6[1-5]|71|8[1-3]|91)\d{15}(\d|X|x)$/.test(IDCard)){
        return false;
    }
    //出生日期校验
    let year = IDCard.substr(6,4),
        month = parseInt(IDCard.substr(10,2)),
        day = parseInt(IDCard.substr(12,2)),
        birthday = `${year}/${month}/${day}`;
    let d = new Date(birthday),
        dYear = d.getFullYear(),
        dMonth = d.getMonth() + 1,
        dDay = d.getDate(),
        dBirthday = `${dYear}/${dMonth}/${dDay}`;
    if(d == "Invalid Date" || birthday != dBirthday){
        return false;
    }
    //校验位
    let sum = 0,
        weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
        codes = "10X98765432";
    for(var i = 0; i < IDCard.length - 1; i++){
        sum += IDCard[i] * weights[i];
    }
    let last = codes[sum % 11];
    if(IDCard.substr(17,1).toLocaleUpperCase() != last){
        return false;
    }
    //信息读取
    let cDate = new Date(),
        cYear = cDate.getFullYear(),
        cMonth = cDate.getMonth() + 1,
        cDay = cDate.getDate();
    let info = {};
    info.sex = (parseInt(IDCard.substr(16,1)) % 2) == 1 ? 1 : 2;//1男 2女
    info.dateBirth = birthday;
    info.age = cYear - year;
    return info;
}

const uniWebView = function(){
    return new Promise((resolve, reject) => {
        let uniWebview = document.getElementById('uni-webview');
        if(!uniWebview){
            let script1 = document.createElement('script');
                script1.src = process.env.VUE_APP_PUBLIC_URL + '/js/jweixin-1.4.0.js';
                script1.id = 'jweixin';
                let script2 = document.createElement('script');
                script2.src = process.env.VUE_APP_PUBLIC_URL + '/js/uni.webview.js';
                script2.id = 'uni-webview';
                document.documentElement.appendChild(script1);
                document.documentElement.appendChild(script2);
                if (window.UniAppJSBridge) {
                    resolve(window.uni && window.uni.webView);
                } else {
                    document.addEventListener('UniAppJSBridgeReady', function () {
                        resolve(window.uni && window.uni.webView);
                    });
                }
        }else{
            resolve(window.uni && window.uni.webView);
        }
    })
}
module.exports={
    BV,
    setupWKWebViewJavascriptBridge,
    dateFormat,
    numberToChinese,
    ellipsis,
    textEncryption,
    analyzeIDCard,
    convertSize,
    identityCard,
    uniWebView
}

